import React from 'react';
import { observer } from 'mobx-react-lite';
import { InputGroup } from '@blueprintjs/core';

import { isAlive } from 'mobx-state-tree';

import { useInfiniteAPI } from 'polotno/utils/use-api';

import { SectionTab } from 'polotno/side-panel';
import { svgToURL } from 'polotno/utils/svg';
import { getKey } from 'polotno/utils/validate-key';
import FaVectorSquare from '@meronex/icons/fa/FaVectorSquare';

import { ImagesGrid } from 'polotno/side-panel/images-grid';

const API = 'https://api.polotno.dev/api';

export const MaIconsPanel = observer(({ store }) => {

    const { data, isLoading, loadMore, setQuery } = useInfiniteAPI({
        defaultQuery: 'house',
        getAPI: ({ page, query }) =>
            `${API}/get-iconfinder?query=${query}&offset=${page}&KEY=${getKey()}`,
        getSize: (res) => {
            return Math.ceil(res.total_count / 50);
        },
    });

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <InputGroup
                leftIcon='search'
                placeholder='Procurar...'
                onChange={(e) => {
                    setQuery(e.target.value);
                }}
                style={{
                    marginBottom: '20px',
                }}
            />
            <ImagesGrid
                shadowEnabled={false}
                images={data?.map((data) => data.icons).flat()}
                getPreview={(item) => item.raster_sizes[6].formats[0].preview_url}
                isLoading={isLoading}
                onSelect={async (item, pos, element) => {
                    const { download_url } = item.vector_sizes[0].formats[0];
                    if (element && element.type === 'image' && !element.locked) {
                        const req = await fetch(
                            `${API}/download-iconfinder?download_url=${download_url}&KEY=${getKey()}`
                        );
                        const json = await req.json();
                        const base64 = await svgToURL(json.content);
                        element.set({ clipSrc: base64 });
                        return;
                    }
                    const width = item.vector_sizes[0].size_width;
                    const height = item.vector_sizes[0].size_height;
                    store.history.transaction(async () => {
                        const x = (pos?.x || store.width / 2) - width / 2;
                        const y = (pos?.y || store.height / 2) - height / 2;
                        const svg = store.activePage?.addElement({
                            type: 'svg',
                            width,
                            height,
                            x,
                            y,
                        });
                        const req = await fetch(
                            `${API}/download-iconfinder?download_url=${download_url}&KEY=${getKey()}`
                        );
                        const json = await req.json();
                        const base64 = await svgToURL(json.content);
                        if (isAlive(svg)) {
                            await svg.set({ src: base64 });
                        }
                    });
                }}
                rowsNumber={4}
                loadMore={loadMore}
            />
        </div>
    );
});

export const MaIconsSection = {
    name: 'iconfinder',
    Tab: (props) => (
        <SectionTab name='Icons' {...props}>
            <FaVectorSquare />
        </SectionTab>
    ),
    Panel: MaIconsPanel,
};
